import React, { useContext } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import audiencesRecipients from '../../../../../assets/images/recipients.svg';
import audiencesRecipientsGrayscale from '../../../../../assets/images/recipients-grayscale.svg';
import classes from './RecipientsData.module.scss';
import { WMIconUndo, WMIconWarning, WMTooltip } from '@walkme/wm-ui';
import { getFormatNumberString } from '../../../../helpers/getFormatNumberString';
import { useGetCalculateRecipientsSizeQuery } from '../../../../../generated/apollo-hooks';
import RecipientsList from './RecipientsList/RecipientsList';
import useSelector from '../../../../infrastructure/useSelector';
import { CreateAudienceDialogContext } from '../CreateAudienceDialogContext';
import { useTranslation } from 'react-i18next';

const keyPrefix = 'components.audiences.createAudienceDialog.recipientsData.recipientsData';

function RecipientsData() {
    const { t } = useTranslation('', { keyPrefix });
    const { rules, dataTestId: parentDataTestId } = useContext(CreateAudienceDialogContext);
    const systemId = useSelector(store => store.common.currentSystem);

    const { data, error, refetch, loading } = useGetCalculateRecipientsSizeQuery({
        skip: !systemId || !rules?.length,

        variables: {
            rules: rules!,
            systemId
        }
    });

    const count = data?.getCalculateRecipientsSize.active;

    const dataTestId = `${parentDataTestId}-recipients-data`;

    return (
        <div className={classes.totalRecipientsContent} data-testid={`${dataTestId}`}>
            <div className={classes.counterContainer}>
                {loading ? (
                    <div className={classes.loading} data-testid={`${dataTestId}-loading`}>
                        <CircularProgress />
                        <div className={classes.description}>{t('calculating')}</div>
                    </div>
                ) : error ? (
                    <div className={classes.error}>
                        <WMIconWarning size={16} color="var(--wmError)" />
                        <div className={classes.errorText}>{t('errorText')}</div>
                        <div className={classes.refreshContainer} onClick={() => refetch()}>
                            <div className={classes.refresh}>
                                <WMIconUndo className={classes.upper} color={'var(--wmPrimary)'} size={24} />
                                <WMIconUndo className={classes.bottom} color={'var(--wmPrimary)'} size={24} />
                            </div>
                            {t('retry')}
                        </div>
                    </div>
                ) : (
                    <div className={classes.content}>
                        <div className={classes.count}>
                            <div className={classes.countNum} data-testid={`${dataTestId}-counter-count`}>
                                {getFormatNumberString(count ?? 0)}
                            </div>

                            <div className={classes.countText}>{t('recipients')}</div>
                        </div>

                        <div className={classes.totalRecipsDescription}>
                            <span>{t('realTimeInfoText')}</span>

                            <WMTooltip title={t('realTimeTooltipText')}>
                                <div className={classes.tooltipIcon}>?</div>
                            </WMTooltip>
                        </div>
                    </div>
                )}
                <img
                    className={classes.img}
                    src={!count ? audiencesRecipientsGrayscale : audiencesRecipients}
                    alt={t('alt')}
                    data-testid={`${dataTestId}-counter-img`}
                />
            </div>

            <div className={classes.recipientsListContainer}>
                {!error && !loading && !count ? (
                    <div className={classes.emptyInfo}>
                        {rules?.length ? (
                            <span className={classes.badValues}>{t('emptyStateTextBadValues')}</span>
                        ) : (
                            <span className={classes.description}>{t('emptyStateText')}</span>
                        )}
                    </div>
                ) : (
                    rules && <RecipientsList rules={rules} />
                )}
            </div>
        </div>
    );
}

export default RecipientsData;
